package com.dotpx.ambient

data class AmbienceVisualSignal(
    val sound: AmbienceVisualSound = AmbienceVisualSound.Room,
    val weight: Float = 0f,
    val convergence: Float = 0f,
    val energy: Float = 0f,
)

data class AmbienceVisualFrame(
    val signals: List<AmbienceVisualSignal> = emptyList(),
    // Full-strength destination bases plus audible events from both scenes.
    val lightSignals: List<AmbienceVisualSignal> = signals,
    val baseTransitionGeneration: Long = 0L,
    val baseTransitionProgress: Float = 1f,
) {
    companion object {
        val Idle = AmbienceVisualFrame(
            listOf(AmbienceVisualSignal(weight = 1f, convergence = 0.38f, energy = 0.22f)),
        )
    }
}
